import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
          <g>
            <path d="M0 0H24V24H0z" />
            <path
              fill={props.fill || "#818c99"}
              fillRule="nonzero"
              d="M8.8 4C7.813 4 7 4.813 7 5.8v12.4c0 .987.813 1.8 1.8 1.8h6c.987 0 1.8-.813 1.8-1.8V5.8c0-.987-.813-1.8-1.8-1.8h-6zm0 1.2h6c.339 0 .6.261.6.6v12.4c0 .339-.261.6-.6.6h-6c-.339 0-.6-.261-.6-.6V5.8c0-.339.261-.6.6-.6zm3 1.2c-.331 0-.6.269-.6.6 0 .331.269.6.6.6.331 0 .6-.269.6-.6 0-.331-.269-.6-.6-.6zm-1 10c-.216-.003-.418.11-.527.298-.109.186-.109.418 0 .604.11.187.31.301.527.298h2c.216.003.418-.11.527-.298.109-.186.109-.418 0-.604-.11-.187-.31-.301-.527-.298h-2z"
            />
          </g>
        </g>
      </svg>
    </>
  );
};
